import { Overlay } from '@mantine/core'

import type { ResponsiveOverlayProps } from '@/components/ResponsiveOverlay/ResponsiveOverlay.types'

import { useIsMobileDevice } from '@/helpers/isMobileDevice.helper'

import classes from './ResponsiveOverlay.module.css'

export function ResponsiveOverlay({
  isVisible,
  visibleOnMobile = true,
  ...props
}: ResponsiveOverlayProps) {
  const isMobileDevice = useIsMobileDevice()

  return (
    (!isMobileDevice || visibleOnMobile) && (
      <Overlay
        backgroundOpacity={isVisible ? 0.6 : 0}
        className={classes.overlay}
        fixed
        {...props}
      />
    )
  )
}
